// extracted by mini-css-extract-plugin
export default {"container":"container-xBGEI1Rw","confetti":"confetti-_MKBfzsS"};